// import React, { Fragment, useState, useEffect, useLayoutEffect } from "react";
// import logo from "../../../assets/images/endless-logo.png";
// import logo_compact from "../../../assets/images/logo/compact-logo.png";
// import { useSelector } from "react-redux";
// import { useLocation, withRouter } from "react-router";

import { useToggle } from "../../../context/contextProvider";
import "./sidebar.css"
import SidebarMenu from "./sidebarMenu";

// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import UserPanel from "./userPanel";
// import { MENUITEMS_ADMIN, MENUITEMS_DEALER } from "../../../constant/menu";
// import { Link, Redirect } from "react-router-dom";
// import { translate } from "react-switch-lang";
// import { AlignLeft } from "react-feather";
// import store from "store";

// function useWindowSize(wrapper) {
//   const [size, setSize] = useState([0, 0]);

//   useLayoutEffect(() => {
//     function updateSize() {
//       setSize([window.innerWidth, window.innerHeight]);
//     }
//     window.addEventListener("resize", updateSize);
//     updateSize();
//     return () => window.removeEventListener("resize", updateSize);
//   }, []);

//   if (wrapper === "horizontal_sidebar") {
//     if (size[0] > 100 && size[0] < 991) {
//       document.querySelector(".page-wrapper").className =
//         "page-wrapper default";
//       document.querySelector(".page-body-wrapper").className =
//         "page-body-wrapper default";
//     } else {
//       document.querySelector(".page-wrapper").className =
//         "page-wrapper horizontal_sidebar";
//       document.querySelector(".page-body-wrapper").className =
//         "page-body-wrapper horizontal_sidebar";
//     }
//   }

//   return size;
// }

// const Sidebar = (props) => {
//   //console.log({ props });
//   var MENUITEMS = MENUITEMS_DEALER;
//   if (store.get("staffMember").accessLevel === 2) {
//     //
//     // if (MENUITEMS[0]["title"] === "Staff Members") {
//     //   MENUITEMS.splice(0, 1);
//     // }
//     // delete MENUITEMS[1];

//     MENUITEMS = MENUITEMS_ADMIN;
//     console.log({ MENUITEMS });
//   }
//   const [margin, setMargin] = useState(0);
//   const [hideRightArrow, setHideRightArrow] = useState(false);
//   const [hideLeftArrow, setHideLeftArrow] = useState(true);
//   const [mainmenu, setMainMenu] = useState(MENUITEMS);
//   const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(false);
//   const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
//   const configDB = useSelector((content) => content.Customizer.sidebar_types);
//   const layout = useSelector((content) => content.Customizer.layout);
//   const [width, height] = useWindowSize(configDB.wrapper);
//   let location = useLocation();
//   const [modal, setModal] = useState();
//   const toggle = () => {
//     setModal(!modal);
//   };
//   useEffect(() => {
//     const currentUrl = location.pathname;
//     mainmenu.filter((items) => {
//       if (items.path === currentUrl) setNavActive(items);
//       if (!items.children) return false;
//       items.children.filter((subItems) => {
//         if (subItems.path === currentUrl) setNavActive(subItems);
//         if (!subItems.children) return false;
//         subItems.children.filter((subSubItems) => {
//           if (subSubItems.path === currentUrl) setNavActive(subSubItems);
//         });
//       });
//     });
//   }, []);
//   const logout = (e) => {
//     localStorage.clear();
//     // window.location.reload();
//     // return <Redirect to="/login"></Redirect>;
//     // this.props.history.push(`${process.env.PUBLIC_URL}/login`);
//     props.history.push(`${process.env.PUBLIC_URL}/login`);
//   };
//   const setNavActive = (item) => {
//     MENUITEMS.filter((menuItem) => {
//       if (menuItem != item) menuItem.active = false;
//       if (menuItem.children && menuItem.children.includes(item))
//         menuItem.active = true;
//       if (menuItem.children) {
//         menuItem.children.filter((submenuItems) => {
//           if (submenuItems.children && submenuItems.children.includes(item)) {
//             menuItem.active = true;
//             submenuItems.active = true;
//           }
//         });
//       }
//     });
//     item.active = !item.active;
//     setMainMenu({ mainmenu: MENUITEMS });
//   };

//   // Click Toggle menu
//   const toggletNavActive = (item) => {
//     if (!item.active) {
//       MENUITEMS.forEach((a) => {
//         if (MENUITEMS.includes(item)) a.active = false;
//         if (!a.children) return false;
//         a.children.forEach((b) => {
//           if (a.children.includes(item)) {
//             b.active = false;
//           }
//           if (!b.children) return false;
//           b.children.forEach((c) => {
//             if (b.children.includes(item)) {
//               c.active = false;
//             }
//           });
//         });
//       });
//     }
//     item.active = !item.active;
//     setMainMenu({ mainmenu: MENUITEMS });
//   };

//   const scrollToRight = () => {
//     const elmnt = document.getElementById("myDIV");
//     const menuWidth = elmnt.offsetWidth;
//     const temp = menuWidth + margin;
//     // Checking condition for remaing margin
//     if (temp < menuWidth) {
//       setMargin(-temp);
//       setHideRightArrow(true);
//     } else {
//       setMargin((margin) => (margin += -width));
//       setHideLeftArrow(false);
//     }
//   };

//   const scrollToLeft = () => {
//     // If Margin is reach between screen resolution
//     if (margin >= -width) {
//       setMargin(0);
//       setHideLeftArrow(true);
//     } else {
//       setMargin((margin) => (margin += width));
//       setHideRightArrow(false);
//     }
//   };

//   const scrollToLeftRTL = () => {
//     if (margin <= -width) {
//       setMargin((margin) => (margin += -width));
//       setHideLeftArrowRTL(true);
//     } else {
//       setMargin((margin) => (margin += -width));
//       setHideRightArrowRTL(false);
//     }
//   };

//   const scrollToRightRTL = () => {
//     const temp = width + margin;
//     // Checking condition for remaing margin
//     if (temp === 0) {
//       setMargin(temp);
//       setHideRightArrowRTL(true);
//     } else {
//       setMargin((margin) => (margin += width));
//       setHideRightArrowRTL(false);
//       setHideLeftArrowRTL(false);
//     }
//   };
//   const [sidebar, setSidebar] = useState(false);
//   const openCloseSidebar = () => {
//     if (sidebar) {
//       setSidebar(!sidebar);
//       document.querySelector(".page-main-header").classList.remove("open");
//       document.querySelector(".page-sidebar").classList.remove("open");
//     } else {
//       setSidebar(!sidebar);
//       document.querySelector(".page-main-header").classList.add("open");
//       document.querySelector(".page-sidebar").classList.add("open");
//     }
//   };

//   var isVisible = window.location.hash.includes("/enrolled-exam");
//   console.log({ isVisible }, "window");
//   return (
//     <Fragment>
//       <div className="page-sidebar" style={{ background: "#0b3672" }}>
//         {isVisible && (
//           <div className="main-header-left d-none d-lg-block">
//             <div className="logo-wrapper compactLogo">
//               <Link to={`${process.env.PUBLIC_URL}/dashboard/home`}>
//                 <img className="blur-up lazyloaded" src={logo_compact} alt="" />
//                 <h2 style={{ color: "#ffffff" }}> Admin</h2>
//               </Link>
//             </div>
//             <div
//               className="page-main-header"
//               style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "15px",
//                 color: "#fbfbfb",
//               }}
//             >
//               <div className="main-header-left d-lg-none">
//                 <div className="logo-wrapper">
//                   <Link to="/dashboard/home">
//                     <img className="img-fluid" src={logo} alt="" />
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//         <div className="sidebar custom-scrollbar">
//           <UserPanel />
//           <ul
//             className="sidebar-menu"
//             id="myDIV"
//             style={
//               configDB.wrapper === "horizontal_sidebar"
//                 ? layout === "rtl"
//                   ? { marginRight: margin + "px" }
//                   : { marginLeft: margin + "px" }
//                 : { margin: "0px" }
//             }
//           >
//             <li
//               className={`left-arrow ${
//                 layout == "rtl"
//                   ? hideLeftArrowRTL
//                     ? "d-none"
//                     : "hideLeftArrowRTL"
//                   : hideLeftArrow
//                   ? "d-none"
//                   : "hideLeftArrow"
//               }`}
//               onClick={
//                 configDB.wrapper === "horizontal_sidebar" && layout === "rtl"
//                   ? scrollToLeftRTL
//                   : scrollToLeft
//               }
//             >
//               <i className="fa fa-angle-left"></i>
//             </li>
//             {MENUITEMS.map((menuItem, i) => (
//               <li className={`${menuItem.active ? "active" : ""}`} key={i}>
//                 {menuItem.sidebartitle ? (
//                   <div className="sidebar-title">{menuItem.sidebartitle}</div>
//                 ) : (
//                   ""
//                 )}

//                 {menuItem.type === "onClick" ? (
//                   <a
//                     className="sidebar-header"
//                     // href="#javascript"
//                     onClick={toggle}
//                   >
//                     {menuItem.customIcon ? (
//                       <i
//                         className={menuItem.icon}
//                         style={{
//                           width: "14px",
//                           height: "14px",
//                           marginRight: "14px",
//                           strokeWidth: "3px",
//                           verticalAlign: "sub",
//                         }}
//                       ></i>
//                     ) : (
//                       <menuItem.icon />
//                     )}
//                     <span>{props.t(menuItem.title)}</span>
//                     {/* <i className="fa fa-angle-right pull-right"></i> */}
//                     <Modal isOpen={modal} toggle={toggle}>
//                       <ModalHeader toggle={toggle}>Log out</ModalHeader>
//                       <ModalBody>
//                         Are you sure you want to logout from Admin Dashboard?
//                       </ModalBody>
//                       <ModalFooter>
//                         <Button color="default" onClick={toggle}>
//                           Cancel
//                         </Button>
//                         <Button color="danger" onClick={() => logout()}>
//                           Confirm
//                         </Button>
//                       </ModalFooter>
//                     </Modal>
//                   </a>
//                 ) : (
//                   ""
//                 )}
//                 {menuItem.type === "sub" ? (
//                   <a
//                     className="sidebar-header"
//                     // href="#javascript"
//                     onClick={() => toggletNavActive(menuItem)}
//                   >
//                     {menuItem.customIcon ? (
//                       <i
//                         className={menuItem.icon}
//                         style={{
//                           width: "14px",
//                           height: "14px",
//                           marginRight: "14px",
//                           strokeWidth: "3px",
//                           verticalAlign: "sub",
//                         }}
//                       ></i>
//                     ) : (
//                       <menuItem.icon />
//                     )}
//                     <span>{props.t(menuItem.title)}</span>
//                     <i className="fa fa-angle-right pull-right"></i>
//                   </a>
//                 ) : (
//                   ""
//                 )}
//                 {menuItem.type === "link" ? (
//                   <Link
//                     to={`${process.env.PUBLIC_URL}${menuItem.path}`}
//                     className={`sidebar-header ${
//                       menuItem.active ? "active" : ""
//                     }`}
//                     onClick={() => toggletNavActive(menuItem)}
//                   >
//                     {menuItem.customIcon ? (
//                       <i
//                         className={menuItem.icon}
//                         style={{
//                           width: "14px",
//                           height: "14px",
//                           marginRight: "14px",
//                           strokeWidth: "3px",
//                           verticalAlign: "sub",
//                         }}
//                       ></i>
//                     ) : (
//                       <menuItem.icon />
//                     )}
//                     <span>{props.t(menuItem.title)}</span>
//                     {menuItem.children ? (
//                       <i className="fa fa-angle-right pull-right"></i>
//                     ) : (
//                       ""
//                     )}
//                   </Link>
//                 ) : (
//                   ""
//                 )}
//                 {menuItem.children ? (
//                   <ul
//                     className={`sidebar-submenu ${
//                       menuItem.active ? "menu-open" : ""
//                     }`}
//                     style={
//                       menuItem.active
//                         ? { opacity: 1, transition: "opacity 500ms ease-in" }
//                         : {}
//                     }
//                   >
//                     {menuItem.children.map((childrenItem, index) => (
//                       <li
//                         key={index}
//                         className={
//                           childrenItem.children
//                             ? childrenItem.active
//                               ? "active"
//                               : ""
//                             : ""
//                         }
//                       >
//                         {childrenItem.type === "sub" ? (
//                           <a
//                             // href="#javascript"
//                             onClick={() => toggletNavActive(childrenItem)}
//                           >
//                             <i className="fa fa-circle"></i>
//                             {props.t(childrenItem.title)}{" "}
//                             <i className="fa fa-angle-right pull-right"></i>
//                           </a>
//                         ) : (
//                           ""
//                         )}

//                         {childrenItem.type === "link" ? (
//                           <Link
//                             to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
//                             className={childrenItem.active ? "active" : ""}
//                             onClick={() => toggletNavActive(childrenItem)}
//                           >
//                             <i className="fa fa-circle"></i>
//                             {props.t(childrenItem.title)}{" "}
//                           </Link>
//                         ) : (
//                           ""
//                         )}
//                         {childrenItem.children ? (
//                           <ul
//                             className={`sidebar-submenu ${
//                               childrenItem.active ? "menu-open" : "active"
//                             }`}
//                           >
//                             {childrenItem.children.map(
//                               (childrenSubItem, key) => (
//                                 <li
//                                   className={
//                                     childrenSubItem.active ? "active" : ""
//                                   }
//                                   key={key}
//                                 >
//                                   {childrenSubItem.type === "link" ? (
//                                     <Link
//                                       to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
//                                       className={
//                                         childrenSubItem.active ? "active" : ""
//                                       }
//                                       onClick={() =>
//                                         toggletNavActive(childrenSubItem)
//                                       }
//                                     >
//                                       <i className="fa fa-circle"></i>
//                                       {props.t(childrenSubItem.title)}
//                                     </Link>
//                                   ) : (
//                                     ""
//                                   )}
//                                 </li>
//                               )
//                             )}
//                           </ul>
//                         ) : (
//                           ""
//                         )}
//                       </li>
//                     ))}
//                   </ul>
//                 ) : (
//                   ""
//                 )}
//               </li>
//             ))}
//             <li
//               className={`right-arrow ${
//                 layout == "rtl"
//                   ? hideRightArrowRTL
//                     ? "d-none"
//                     : "hideRightArrowRTL"
//                   : hideRightArrow
//                   ? "d-none"
//                   : "hideRightArrow"
//               }`}
//               onClick={
//                 configDB.wrapper == "horizontal_sidebar" && layout == "rtl"
//                   ? scrollToRightRTL
//                   : scrollToRight
//               }
//             >
//               <i className="fa fa-angle-right"></i>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </Fragment>
//   );
// };

// export default withRouter(translate(Sidebar));


const Sidebar = () => {
  const { isOpen, close } = useToggle();

  return (
    <>
      {/* Overlay – mobile only via CSS */}
      <div
        className={`sidebar-overlay ${isOpen ? "show" : ""}`}
        onClick={close}
      />

      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <div className="sidebar-profile">
          <UserPanel />
        </div>
        <SidebarMenu />
      </div>
    </>
  );
};

export default Sidebar;



